import PropTypes from 'prop-types'
import React from 'react'

import SkuImage from '@/checkout-instore-legacy/components/Commons/SkuImage'
import { SimpleListItem } from '@/checkout-instore-legacy/components/Commons/Elements/SimpleList'

export default function Gift({ gift, onClick }) {
  let selectContent

  if (gift.isSelected) {
    selectContent = <i className="c-action-primary fa fa-dot-circled" />
  } else {
    selectContent = <i className="light-gray fa fa-circle-empty" />
  }

  const tablet = window.innerWidth > 600
  const iconSize = tablet ? 110 : 70

  const iconWrapper = (
    <div className={`dib ml3 ${tablet ? 'f2' : 'f3'}`}>{selectContent}</div>
  )

  return (
    <SimpleListItem
      img={<SkuImage url={gift.imageUrl} width={iconSize} height={iconSize} />}
      icon={iconWrapper}
      onClick={onClick}
      compact
    >
      <div className="productlist-item-name fw4 lh-title t-body mb3 f5 f4-ns c-on-base">
        {gift.name}
      </div>
    </SimpleListItem>
  )
}

Gift.propTypes = {
  gift: PropTypes.object,
  onClick: PropTypes.func,
}
